import React from 'react';

const SCROLL_LOCK_CLASS = 'scroll-locked';

export const restoreBodyScroll = () => {
  document.body.style.overflow = '';
  document.body.style.touchAction = '';
  document.body.classList.remove(SCROLL_LOCK_CLASS, 'modal-open');
};

export const useScrollLock = () => {
  const lockScroll = React.useCallback(() => {
    document.body.classList.add(SCROLL_LOCK_CLASS);
  }, []);

  const unlockScroll = React.useCallback(() => {
    document.body.classList.remove(SCROLL_LOCK_CLASS);
  }, []);

  return [lockScroll, unlockScroll];
};
